import { ExportCsvButton } from '../../components/ui';
import { downloadCsv } from '../../utils/csv.js';

// Built in the browser: the endpoint returns the whole (short) list, so "all
// rows" and "the rows on screen" are the same set.
const CSV_COLUMNS = [
  { key: 'id',                    label: 'Batch ID' },
  { key: 'total_punches',         label: 'Total Punches' },
  { key: 'mapped_count',          label: 'Mapped' },
  { key: 'gap_count',             label: 'Gaps' },
  { key: 'total_billable_hours',  label: 'Billable Hours' },
  { key: 'total_excluded_hours',  label: 'Excluded Hours' },
  { key: 'ot_eligible_count',     label: 'OT Eligible' },
  { key: 'status',                label: 'Status' },
  { key: 'created_at',            label: 'Created' },
];

export function ProcessingTable({ batches }) {
  if (!batches?.processing_batches?.length) return null;
  return (
    <div className="section">
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        gap: 12, flexWrap: 'wrap',
      }}>
        <div className="section-title">Processing Results</div>
        <ExportCsvButton
          onExport={() => downloadCsv(
            'processing-results', batches.processing_batches, CSV_COLUMNS,
          )}
          title="Download these processing results as CSV"
        />
      </div>
      <table>
        <thead>
          <tr>
            <th>Total Punches</th><th>Mapped</th><th>Gaps</th>
            <th>Billable Hours</th><th>Excluded Hours</th>
            <th>OT Eligible</th><th>Status</th>
          </tr>
        </thead>
        <tbody>
          {batches.processing_batches.map((p) => (
            <tr key={p.id}>
              <td>{p.total_punches}</td>
              <td style={{ color: '#155724', fontWeight: 600 }}>{p.mapped_count}</td>
              <td style={{ color: p.gap_count > 0 ? '#721c24' : '#666' }}>{p.gap_count}</td>
              <td>{p.total_billable_hours}h</td>
              <td>{p.total_excluded_hours}h</td>
              <td>{p.ot_eligible_count}</td>
              <td>
                <span className={`badge ${p.status === 'completed' ? 'approved' : p.status}`}>
                  {p.status}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
